export const TX_DESK_VIEWS = [
  { id: "all", label: "All ledger", hint: "Full history" },
  { id: "deposits", label: "Deposits", hint: "Money in" },
  { id: "withdrawals", label: "Withdrawals", hint: "Money out" },
  { id: "needs_action", label: "Needs action", hint: "Pending · Hold" },
  { id: "failed", label: "Failed", hint: "Failed · Cancelled" },
  { id: "mobile", label: "Mobile money", hint: "MTN · Airtel" },
];

export const TX_STATUS_FILTERS = [
  { value: "All", label: "Any status" },
  { value: "Success", label: "Success" },
  { value: "Pending", label: "Pending" },
  { value: "Hold", label: "On hold" },
  { value: "Failed", label: "Failed" },
  { value: "Cancelled", label: "Cancelled" },
];

export const TX_CURRENCY_FILTERS = [
  { value: "All", label: "Any currency" },
  { value: "CASH", label: "CASH" },
  { value: "COIN", label: "COIN" },
];

export const TX_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "amount", label: "Largest amount" },
  { value: "amount_asc", label: "Smallest amount" },
];

export function sortTransactions(transactions = [], sortKey = "newest") {
  const list = [...transactions];
  switch (sortKey) {
    case "oldest":
      return list.sort(
        (a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
      );
    case "amount":
      return list.sort((a, b) => (Number(b.amount) || 0) - (Number(a.amount) || 0));
    case "amount_asc":
      return list.sort((a, b) => (Number(a.amount) || 0) - (Number(b.amount) || 0));
    default:
      return list.sort(
        (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
      );
  }
}

export function clientFilterTransactions(transactions = [], search = "") {
  const q = search.trim().toLowerCase();
  if (!q) return transactions;
  return transactions.filter((tx) => {
    const hay = [
      tx.transactionType,
      tx.transactionRef,
      tx.transactionId,
      tx.userName,
      tx.userEmail,
      tx.userCode,
      tx.status,
      tx.method,
      tx.description,
      tx.phoneNumber,
      tx.currency,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}
